import { useState, useEffect, Suspense } from "react";
import {
  faDashboard,
  faGears,
  faHome,
  faUser,
  faMoneyBill,
  faBasketShopping,
  faBriefcase,
  faUsers,
  faBlog,
  faHdd,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import Dashboard from "../../components/Dashboard/Main";
import { notificationService } from "../../services";
import ScrollToTop from "../../hooks/ScrollToTop";
import Spinner from "../../components/UI/Spinner";
import { Outlet } from "react-router-dom";

export default function AdminDashboard(props) {
  const [notificationsCount, setNotificationsCount] = useState(0);

  useEffect(() => {
    async function getNewNotifications() {
      const notificationsCount =
        await notificationService.newNotificationCounterAdmin();
      setNotificationsCount(notificationsCount);
    }
    getNewNotifications();
  }, []);

  const links = [
    {
      name: "Home",
      url: "/admin",
      icon: faDashboard,
    },
    {
      name: "Users",
      url: "#",
      icon: faUsers,
      subLinks: [
        { name: "All", url: "users/all" },
        { name: "Admins", url: "users/admins" },
        { name: "Users", url: "users/users" },
      ],
    },
    {
      name: "Assets",
      url: "#",
      icon: faBriefcase,
      subLinks: [
        { name: "All", url: "assets/all" },
        { name: "Available", url: "assets/available" },
        { name: "Featured", url: "assets/featured" },
        { name: "Sold", url: "assets/sold" },
      ],
    },
    {
      name: "Order",
      url: "#",
      icon: faBasketShopping,
      subLinks: [
        { name: "All", url: "orders/all" },
        { name: "Uncredentialed", url: "orders/uncredentialed" },
        { name: "Credentialed", url: "orders/credentialed" },
        { name: "Confirmed", url: "orders/credentials_viewed" },
        { name: "Completed", url: "orders/completed" },
        { name: "Cancelled", url: "orders/cancelled" },
      ],
    },
    {
      name: "Transactions",
      url: "#",
      icon: faMoneyBill,
      subLinks: [
        { name: "All", url: "transactions/all" },
        { name: "Credit", url: "transactions/credit" },
        { name: "Debit", url: "transactions/debit" },
      ],
    },
    {
      name: "Wallet",
      url: "wallet",
      icon: faMoneyBill,
    },
    {
      name: "Blog",
      url: "#",
      icon: faBlog,
      subLinks: [
        { name: "All", url: "blog/posts" },
        { name: "New Post", url: "blog/posts/new" },
      ],
    },
    {
      name: "Platform",
      url: "#",
      icon: faHdd,
      subLinks: [
        { name: "All", url: "platforms" },
        { name: "New Platform", url: "platforms/new" },
      ],
    },
    {
      name: "Category",
      url: "#",
      icon: faLayerGroup,
      subLinks: [
        { name: "All", url: "categories" },
        { name: "New Category", url: "categories/new" },
      ],
    },
    {
      name: "My Profile",
      url: "profile",
      icon: faUser,
    },
    {
      name: "Settings",
      url: "/user/my-dashboard/settings",
      icon: faGears,
    },
    {
      name: "Site",
      url: "/",
      icon: faHome,
    },
  ];

  const navLinks = [{ name: "Me", url: "/admin/my-profile", icon: faUser }];
  return (
    <Dashboard
      sidebarLinks={links}
      navBarTitle={"Admin Dashboard"}
      navLinks={navLinks}
      profileTitle={"Admin"}
      notificationCount={notificationsCount}
    >
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="grid place-items-center min-h-[50vh]">
            <Spinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Dashboard>
  );
}
